class Validators {
  static required = (value: string | undefined | null): boolean => {
    return !(value === undefined || value === null || value.trim() === '');
  };

  static valuesMatch = (value1: string, value2: string): boolean => {
    return value1 === value2;
  };

  static passwordPolicy = (value: string): boolean => {
    // 1 upper, 1 lower, 1 number, 1 special, at least 8 chars
    const policy = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return policy.test(value);
  };

  static requiredEmail = (value: string): boolean => {
    return this.required(value) && value.includes('@');
  };
}

export default Validators;
